import { useOpenSearchContext } from 'hooks/useOpenSearchContext';

export function useCardStates() {
  const { isLoadingRequest, isError, isEmpty, isDivergence, isNotActive, searchTruckerData } = useOpenSearchContext();

  const showTruckerSummary =
    !isLoadingRequest && !isDivergence && !isError && !isEmpty && !isNotActive && searchTruckerData;
  const showError = isError && !isDivergence && !isNotActive && !isEmpty;
  const showNotActive = !isLoadingRequest && isNotActive;
  const showLoading = isLoadingRequest;
  const showEmpty = !isLoadingRequest && isEmpty;
  const showDivergence = isDivergence;

  return { showTruckerSummary, showError, showNotActive, showLoading, showEmpty, showDivergence };
}
